import React from 'react';
import { StyleSheet, View, Image } from 'react-native';
import { BEIGE } from '../../settings/colors';
import Logo from '../../assets/images/logo/logo-berry@2x.png';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: BEIGE,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
  },
  logo: { width: 100, height: 40, margin: 20 },
});

function AuthLayout(props) {
  return (
    <View style={styles.container}>
      <a href="/">
        <Image source={Logo} style={styles.logo} />
      </a>
      {props.children}
    </View>
  );
}

export default AuthLayout;
